import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="checkout--gls-parcelshop"
export default class extends Controller {
  static targets = ["openButton", "summary", "title", "address", "hiddenFields"]
  static values = {
    scriptUrl: String,
    lang: { type: String, default: "sk" },
    countryCode: { type: String, default: "SK" }
  }

  connect() {
    this.#loadScript()
  }

  open(event) {
    event.preventDefault()
    if (typeof window.GlsWidget !== "object") {
      console.error("GlsWidget not loaded yet")
      return
    }
    window.GlsWidget.open(this.#onSelect.bind(this), {
      lang: this.langValue,
      find: 1,
      noHeader: 1,
      ctrCode: this.countryCodeValue
    })
  }

  #onSelect(point) {
    this.#setHidden("provider_numeric_id", point.id)
    this.#setHidden("provider_text_id",    point.oldId)
    this.#setHidden("provider_title",      point.title)
    this.#setHidden("street",              point.street)
    this.#setHidden("city",                point.city)
    this.#setHidden("zip",                 point.postalcode)
    this.#setHidden("country_code",        point.countrycode)

    this.titleTarget.textContent = point.title
    this.addressTarget.textContent =
      `${point.street}, ${point.postalcode} ${point.city}`
    this.summaryTarget.classList.remove("hidden")
    this.openButtonTarget.textContent = "Zmeniť výdajné miesto"

    this.element.dispatchEvent(
      new CustomEvent("gls-parcelshop:selected", { bubbles: true })
    )

    if (typeof window.GlsWidget.close === "function") {
      window.GlsWidget.close()
    }
  }

  #setHidden(name, value) {
    const input = this.hiddenFieldsTarget.querySelector(
      `input[name$="[${name}]"]`
    )
    if (input) input.value = value ?? ""
  }

  #loadScript() {
    if (!this.scriptUrlValue) return
    if (document.querySelector(`script[src="${this.scriptUrlValue}"]`)) return
    const s = document.createElement("script")
    s.src = this.scriptUrlValue
    s.async = true
    document.head.appendChild(s)
  }
}
